<div class="brand-text">
    <div class="title"> Innovate your Products.</div>
    <div class="description">Create, evolve, and market your products to consistently grow your business.</div>
</div>
